// extracted by mini-css-extract-plugin
export default {"template":"styles_template__wunL2","templateP":"styles_templateP__NfJ1h"};